// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hvaJKcyZdZkvF0efV2CQ{flex-direction:column;align-items:center;display:flex}.hvaJKcyZdZkvF0efV2CQ .DyRdGBhFCRQbMGW8IQEV{background:var(--green-10);border-radius:100px;justify-content:center;align-items:center;width:80px;height:80px;display:flex}.hvaJKcyZdZkvF0efV2CQ .DyRdGBhFCRQbMGW8IQEV .pTfv_mO9wJYmDKwYQyIw{background:var(--green-70);border-radius:12px;width:32px;height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `hvaJKcyZdZkvF0efV2CQ`,
	"iconWrap": `DyRdGBhFCRQbMGW8IQEV`,
	"icon": `pTfv_mO9wJYmDKwYQyIw`
};
export default ___CSS_LOADER_EXPORT___;
